import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClientDeviceInformationDialogComponent } from './client-device-information-dialog.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [ClientDeviceInformationDialogComponent],
    declarations: [ClientDeviceInformationDialogComponent],
    providers: [],
})
export class ClientDeviceInformationModule { }
